import {maybe} from '@freckle/maybe'

export class HttpError extends Error {
  status: number | undefined | null
  readyState: number | undefined | null

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(err: any) {
    super(createErrorMessage(err))
    this.name = 'HttpError'
    // These propeties are using in filterAndNotify for bugsnag
    this.status = err?.status
    this.readyState = err?.readyState
  }
}

function createErrorMessage(
  err: {status: number | undefined; responseText: string | undefined} | undefined | null
): string {
  const mStatus = err?.status
  const mResponseText = err?.responseText
  const defaultErrMsg = `Unexpected HTTP error`

  return maybe(
    () => defaultErrMsg,
    status =>
      maybe(
        () => defaultErrMsg,
        responseText => `Unexpected HTTP error: ${status} - ${responseText}`,
        mResponseText
      ),
    mStatus
  )
}
